import React from "react";

export default function Map() {
  return (
    <>
      <div className="lg:w-[1300px] lg:h-[1000px] w-[700px] h-[600px] relative mt-20 overflow-hidden">
        <div className="absolute mx-auto lg:top-0 lg:left-0 left-1/2 -translate-x-1/2 lg:translate-x-0">
          <img
            src="/images/whitepaper/bg.svg"
            alt="background"
            className="lg:block hidden"
          />
          <img
            src="/images/whitepaper/mobile-bg.svg"
            alt="background"
            className="lg:hidden translate-y-6"
          />
        </div>
        <div
          className="absolute top-0 lg:top-10 left-[45%] lg:left-[43.5%] font-Red-Undead text-2xl lg:text-[45px] text-primary-green"
          style={{ WebkitTextStroke: "1px #61FF00" }}
        >
          purge
        </div>

        <div className="absolute text-center top-14 left-[30%] lg:text-base text-[11px] lg:top-[216px] lg:left-32 font-bold">
          First Version <span className="lg:inline hidden">-</span>
          <br className="lg:hidden" />
          Single-player
        </div>

        <div className="absolute text-[11px] text-center top-11 right-[29%] lg:top-[216px] lg:right-24 lg:text-base font-bold">
          Ten levels with
          <br className="lg:hidden" />
          increasing difficulty
          <br className="lg:hidden" />
          levels
        </div>

        <div className="absolute lg:text-base text-[10px] text-center top-28 left-[31%] lg:top-[340px] lg:left-56">
          The higher the
          <br className="lg:hidden" />
          level, the more
          <br className="lg:hidden" />
          difficult
        </div>

        <div className="absolute right-[31%] text-center text-[10px] top-28 lg:text-base lg:top-[340px] lg:right-[276px]">
          Each level is
          <br className="lg:hidden" />
          bound by a time
          <br className="lg:hidden" />
          frame
        </div>

        <div className="absolute left-[42%] top-[220px] lg:top-[340px] lg:left-[42.5%] text-[11px] lg:text-base text-center text-[#7C7C7C] ">
          Complete a level within
          <br />
          the stipulated
          <br />
          timeframe, and get
          <br />
          rewarded with an in-
          <br />
          game item. Viz:
          <br />
          characters and <br />
          weapons
          <br />
        </div>

        <div className="absolute text-[21px] bottom-[88px] left-[33%] uppercase font-Red-Undead lg:text-[40px] lg:leading-10 text-center lg:bottom-48 lg:left-[328px]">
          <span
            className="text-primary-green"
            style={{ WebkitTextStroke: "1px #61FF00" }}
          >
            purge <br />
          </span>
          now
        </div>

        <div className="absolute text-[9px] bottom-[30px] left-[30%] lg:text-base lg:bottom-20 lg:left-[310px] text-center text-[#7C7C7C]">
          Mint an NFT or buy one
          <br />
          on the marketplace to
          <br />
          qualify to play.
        </div>

        <div className="absolute lg:bottom-36 lg:right-[330px] bottom-[80px] right-[17%] text-center z-20">
          <img
            src="/images/whitepaper/trophy.svg"
            alt="trophy"
            className="w-1/2"
          />
        </div>

        <div className="font-Red-Undead text-lg bottom-[70px] right-[33%] lg:text-[34px] absolute lg:bottom-36 lg:right-[360px]">
          Awards
        </div>

        <div className="absolute lg:bottom-20 lg:right-[330px] lg:text-base text-[9px] bottom-[30px] right-[30%] text-center text-[#7C7C7C]">
          A weekly leaderboard with
          <br />
          awards to win.
        </div>
      </div>
    </>
  );
}
